// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3TsvU","Success":"Button_Success__1LNcT","Danger":"Button_Danger__3UGWy"};